import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e29aa7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-date-picker" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "date" }
const _hoisted_4 = { class: "day" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", {
      class: _normalizeClass(['date-list', `date-list-${_ctx.product.slug}`]),
      ref: "dateList"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateList, (date, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass([_ctx.getDateItemClass(date, i), "date-item"]),
          onClick: ($event: any) => (_ctx.onDateClick(date)),
          ref_for: true,
          ref: "dateItem"
        }, [
          _createElementVNode("div", _hoisted_3, [
            (i === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("今日")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(date)), 1)
                ], 64))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getDayLabel(date)), 1)
        ], 10, _hoisted_2))
      }), 128))
    ], 2)
  ]))
}